module.exports = __webpack_public_path__ + "img/seminar-1999.2df75b2f.jpg";